export default __webpack_public_path__ + "static/media/buDeleteIcon.3c99ce11.svg";